/**
 * Redux store — combines all RTK Query API slice reducers and middleware.
 *
 * Wrap the app root with <Provider store={store}> in index.js to make
 * all RTK Query hooks available throughout the component tree.
 */

import { configureStore } from '@reduxjs/toolkit';
import { searchApi }    from './api/searchApi';
import { homeApi }      from './api/homeApi';
import { detailsApi }   from './api/detailsApi';
import { targetingApi } from './api/targetingApi';
import { adminApi }     from './api/adminApi';
import { globalApi }    from './api/globalApi';
import { addressApi }   from './api/addressApi';
import { exusApi }      from './api/exusApi';
import { featuresApi }  from './api/featuresApi';
import { homeV3Api }    from './api/homeV3Api';
import { professionalsV3Api }     from './api/professionalsV3Api';
import { organizationsV3Api }     from './api/organizationsV3Api';
import { exUsProfessionalsV3Api } from './api/exUsProfessionalsV3Api';
import { targetingV3Api }         from './api/targetingV3Api';
import { exhibitsDisplaysV3Api }  from './api/exhibitsDisplaysV3Api';
import { adminV3Api }             from './api/adminV3Api';

export const store = configureStore({
    reducer: {
        [searchApi.reducerPath]:    searchApi.reducer,
        [homeApi.reducerPath]:      homeApi.reducer,
        [detailsApi.reducerPath]:   detailsApi.reducer,
        [targetingApi.reducerPath]: targetingApi.reducer,
        [adminApi.reducerPath]:     adminApi.reducer,
        [globalApi.reducerPath]:    globalApi.reducer,
        [addressApi.reducerPath]:   addressApi.reducer,
        [exusApi.reducerPath]:      exusApi.reducer,
        [featuresApi.reducerPath]:          featuresApi.reducer,
        [homeV3Api.reducerPath]:             homeV3Api.reducer,
        [professionalsV3Api.reducerPath]:    professionalsV3Api.reducer,
        [organizationsV3Api.reducerPath]:    organizationsV3Api.reducer,
        [exUsProfessionalsV3Api.reducerPath]: exUsProfessionalsV3Api.reducer,
        [targetingV3Api.reducerPath]:        targetingV3Api.reducer,
        [exhibitsDisplaysV3Api.reducerPath]: exhibitsDisplaysV3Api.reducer,
        [adminV3Api.reducerPath]:            adminV3Api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(searchApi.middleware)
            .concat(homeApi.middleware)
            .concat(detailsApi.middleware)
            .concat(targetingApi.middleware)
            .concat(adminApi.middleware)
            .concat(globalApi.middleware)
            .concat(addressApi.middleware)
            .concat(exusApi.middleware)
            .concat(featuresApi.middleware)
            .concat(homeV3Api.middleware)
            .concat(professionalsV3Api.middleware)
            .concat(organizationsV3Api.middleware)
            .concat(exUsProfessionalsV3Api.middleware)
            .concat(targetingV3Api.middleware)
            .concat(exhibitsDisplaysV3Api.middleware)
            .concat(adminV3Api.middleware),
});
